import { createI18n } from 'vue-i18n';


const de = Object.assign(require('./lang/de'));

const messages = {
  de,
};
const i18n = createI18n({
  locale: 'de',
  fallbackLocale: 'de',
  messages,
});

export default i18n;
